<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="8">
                <h4 class="p-2">Fotografías masivas de alumnos</h4>
            </vs-col>
            <vs-col sm="12" lg="4">
                <vs-button
                    class="ml-auto"
                    success
                    @click="active =! active"
                >
                    Subir fotografías
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo escolar
                    </label>
                    <vs-select filter :loading="loadingCicloEscolar" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Institución" :key="cicloEscolarId" v-model="cicloEscolar" :disabled="!cicloEscolares.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <vs-option v-for="option in cicloEscolares" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="grupo" class="labelInput">
                        Grupo
                    </label>
                    <div class="d-flex" v-if="grupos[0]">
                        <div>
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(grupos, 'grupos')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('grupos')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>

                    </div>
                </div>
                <vs-select multiple filter collapse-chips :loading="loadingGrupo" class="aqui pt-0" id="grupo" placeholder="Seleccionar Institución" :key="grupoId" v-model="grupo" :disabled="!grupos.length" autocomplete="off">
                    <template #message-danger v-if="errorFields.includes('grupo')">
                        Requerido
                    </template>
                    <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                        {{option.text}}
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                   @click="getFotografiasMasivas()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <multiple-fotos v-model="active" @refreshTable="getFotografiasMasivas"></multiple-fotos>
        <fotografias :recargar="recargar" :imagenes="imagenes" :idPersona="idPersona" @refreshTable="getFotografiasMasivas" :personaRol="personaRol" :filtros="filtros" @refreshComponent="getFotografiasMasivas" :key="recargar"></fotografias>
    </div>
</template>
 
<script>
import reportes from '../../../../api/requests/reportes';
import fotografias from './fotos-alumnos.vue'
import MultipleFotos from './multiple-fotos.vue'
export default {
    props: [
        'post',
        'avatar',
        'editable',
        'idPersona',
        'personaRol'
    ],
    data(){
        return{
            institucion:'',
            personaId: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstituto: false,
            cicloEscolar:'',
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            loadingCicloEscolar: false,
            grupo:'',
            grupos: [],
            grupoId: (new Date()).getTime(),
            loadingGrupo: false,
            errorFields: [],
            users: [],
            imagenes: [],
            img: null,
            tipoAlumno: '',
            file: '',
            selectedFile :null,
            active: false,
            recargar: 0,
            filtros: {}
        }
    },
    components: {
        fotografias,
        MultipleFotos
    },
    mounted() {
          const vm = this;
        this.$on('openDialog', function() {
            $('#uploadAvatarInput').click();
            console.log('text');
        });

     $('#uploadAvatarInput').on('change', function (e) {
            const formData = new FormData();
            formData.append('avatar_id', e.target.files[0])
            vm.upload(formData);
        });  
    },
    created(){
        this.getInstituciones();
        this.getImagenes();
    },
    methods:{
        getRefrescar(){
            console.log("entro a fotografias-masivas.vue")
            this.recargar = true
        },
         getNombre(index){
          const nombre = 'uploadAvatarInput' + index
          return nombre
        },
          eventFile(event){
            //  console.log(event)
          this.selectedFile = event.target.files[0]
          console.log(this.selectedFile);

        },

       seleccionar() {
            if(this.editable !== true){
                this.$emit('openDialog');
            }
        },
        upload(data) {
            console.log('entra upload');
           try {
             axios.post('/api/personas/' + this.avatar.id + '/avatar', data, {
                 headers: {'Content-Type': 'multipart/form-data'}
             }).then(res => {
                 location.reload();
             }).catch(e => {
                 console.log('error', e);
             });
           } catch (e) {
           } finally {
           }
        },

        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'grupos'){
                this.grupo = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'grupos'){
                this.grupo = ''
            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch(error){
                this.loadingInstituto = false
               // console.log(error)
            }
        },
        async getCiclosEscolares(){
            try {
                this.loadingCicloEscolar = true
                const response = await reportes.getCiclosEscolares(this.institucion)
                this.cicloEscolares = response.data
                this.cicloEscolarId = (new Date()).getTime()
                this.loadingCicloEscolar = false
            }
            catch(error){
                this.loadingCicloEscolar = false
                console.log(error)
            }
        },
        async getGrupo() {
            if(this.cicloEscolar){
                this.loadingGrupo = true
                const params = {
                    ciclo_escolar_id: this.cicloEscolar
                }
                const { data: response } = await reportes.getGrupo(this.institucion, params)
                this.grupos = response
                this.grupoId = (new Date()).getTime()
                this.loadingGrupo = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar){
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.grupo) {
                this.errorFields.push('grupo')
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                }

                if(this.grupo[0] == ''){
                    const eliminarGrupo = this.grupo.shift()
                    params.grupo_id = this.grupo
                }else{
                    params.grupo_id = this.grupo
                }
                return params
            } else {
                return null
            }
        },
        async getFotografiasMasivas(){
            const params = this.sanityForm()
            if(params){
                this.imagenes = []
                const loading = this.$vs.loading()
                try{
                    const { data: response } = await reportes.getFotografiasMasivas(params) || {}
                    const { opciones: documentInfo } = response || {}
                    this.imagenes = response
                    this.filtros = {
                        institucion: this.institucion,
                        cicloEscolar: this.cicloEscolar,
                        instituciones: this.instituciones,
                        ciclosEscolares: this.cicloEscolares
                    }
                    this.recargar += 1;
                    loading.close();
                }catch{
                    loading.close();
                }
            }
        },

        async getImagenes(){
            if(this.cicloEscolar){
              try {
                let params = {
                    "grupo_id": this.grupo_id,
                    "ciclo_escolar_id": this.cicloEscolar,
                    "institucion_id": this.institucion,
                }
                const { data: response } = await reportes.getFotografiasMasivas(params) || {}
                const { opciones: documentInfo } = response || {}
                this.imagenes = response
                  console.log(this.imagenes)
                           } catch (error) {
                            // this.imagenes = ''
                              console.log('error')
                           }
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },

      
/***se carga el file */
  
 submitFiles(){
      const loading = this.$vs.loading()
       const vue = this
        let formData = new FormData();
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];

          formData.append('files[' + i + ']', file);
        }
        axios.post( '/api/personas/bulkLoad',
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function(){
              vue.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Imagenes cargadas con éxito.'
                    })
              loading.close()
              this.getImagenes();
          console.log('SUCCESS!!');
        })
        .catch(function(){
             vue.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error.',
                        text: 'Error al carga.'
                    })
              loading.close()
          console.log('FAILURE!!');
        });
      },
      handleFilesUpload(){
        this.files = this.$refs.files.files;
        this.submitFiles(); 
        console.log(this.files);
      },
       handleFilesUploadById(persona_id,index){
           const selectedFile = this.$refs['avatar_id'][0].files[0]
              console.log(selectedFile)
           //  const selectedFile = this.$refs['uploadAvatarInput' + index][0].files[0]
            //  console.log(persona_id[index])
             // console.log(index)
//console.log(persona_id,i);
        try {
             axios.post('/api/personas/' + persona_id + '/avatar', data, {
                 headers: {'Content-Type': 'multipart/form-data'}
             }).then(res => {
               console.log('se guarda');
             }).catch(e => {
                 console.log('error', e);
             });
           }catch (e){
           } 
           finally 
           {
           }
           console.log(persona_id);
      //  this.files = this.$refs.avatar_id.files;
       
        //console.log(this.files);
      },
      
    },
    watch:{
        institucion(){
            this.grupo = ''
            this.cicloEscolar = ''
            this.getCiclosEscolares()
            this.getImagenes()

        },
        cicloEscolar(){
            this.grupo = ''
            this.getGrupo()
        }
    }
}
</script>
<!-- SASS styling -->
<style lang="scss">
.preview-zone {
  text-align: center;
}

.preview-zone .box {
  box-shadow: none;
  border-radius: 0;
  margin-bottom: 0;
}

  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    background: red;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  #label {
  background-color: indigo;
  color: white;
  padding: 0.5rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}

</style>
